export default "__VITE_ASSET__5b795178__"